import { gql } from '@grandvisionhq/graphql';

const bookAppointmentType = gql`
  fragment BookAppointmentStoreAppointmentType on StoreAppointmentType {
    id
    name
    description
    duration {
      amount
      unit
    }
    price {
      amount
      currency
    }
    isAvailableInStore
    ageGroup
    tryInStore
    visibleToCustomers
  }
`;
const bookAppointmentStore = gql`
  fragment BookAppointmentStore on Store {
    code
    name
    shortName
    streetName
    streetNumber
    additionalStreetInfo
    postalCode
    town
    province
    country
    lat
    lon
    email
    phone
    slug
    appointmentsAvailable
    appointmentTypes {
      ...BookAppointmentStoreAppointmentType
    }
  }
  ${bookAppointmentType}
`;
const GET_BOOK_APPOINTMENT_STORE = gql`
  query GetBookAppointmentStore($code: Int, $deviceGeoLocation: GeoLocationInput, $slug: String) {
    store(code: $code, deviceGeoLocation: $deviceGeoLocation, slug: $slug) {
      ...BookAppointmentStore
    }
  }
  ${bookAppointmentStore}
`;

export { GET_BOOK_APPOINTMENT_STORE };
//# sourceMappingURL=get-book-appointment-store.js.map
